var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.news)?_c('Markdown',{staticClass:"mt-4",attrs:{"title":_vm.$t2(_vm.news.title),"subtitle":_vm.news.date,"content":_vm.news.md}}):_c('S404')
}
var staticRenderFns = []

export { render, staticRenderFns }